export default __webpack_public_path__ + "static/media/vip-banner.2e411299.svg";